/** REV-22155 — translated column headers of the persons Excel export. */
export interface IPersonExportTableHeaders {
    firstName: string;
    lastName: string;
    street: string;
    additionToAddress: string;
    zip: string;
    city: string;
    email: string;
    phone: string;
    assignee: string;
    clerk: string;
    tags: string;
    companies: string;
}
